import React, { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDate, titleCase, StatusBadge } from "@/lib/format";
import { PageHeader, DataTable, Pager, useList } from "@/components/shared";
import { FormDialog } from "@/components/EntityForm";
import { Button } from "@/components/ui/button";
import { FileCheck2, Plus } from "lucide-react";

const STATUS = ["submitted", "under_review", "documents_pending", "insurer_query", "approved", "issued", "rejected", "cancelled"];

export default function Proposals() {
  const { hasPerm } = useAuth();
  const [customers, setCustomers] = useState([]);
  const { items, total, loading, page, setPage, refetch } = useList("/proposals", {});
  useEffect(() => { api.get("/customers", { params: { limit: 100 } }).then(({ data }) => setCustomers(data.items || [])).catch(() => {}); }, []);
  const create = async (v) => { await api.post("/proposals", v); refetch(); };
  const fields = [
    { name: "customer_id", label: "Customer", type: "select", required: true, options: customers.map((x) => ({ value: x.id, label: `${x.name} (${x.customer_id})` })) },
    { name: "insurer", label: "Insurer" },
    { name: "product", label: "Product" },
    { name: "status", label: "Status", type: "select", options: STATUS.map((s) => ({ value: s, label: titleCase(s) })) },
    { name: "missing_documents", label: "Missing Documents", type: "textarea", full: true },
    { name: "remarks", label: "Remarks", type: "textarea", full: true },
  ];
  const columns = [
    { key: "proposal_number", header: "Proposal No", render: (r) => <span className="font-mono text-xs">{r.proposal_number}</span> },
    { key: "insurer", header: "Insurer", render: (r) => <span className="font-semibold">{r.insurer || "—"}</span> },
    { key: "product", header: "Product", render: (r) => <span className="text-sm text-muted-foreground">{r.product || "—"}</span> },
    { key: "status", header: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "application_date", header: "Applied", render: (r) => <span className="text-sm">{fmtDate(r.application_date)}</span> },
  ];
  return (
    <div>
      <PageHeader title="Proposals" subtitle={`${total} proposals in process`} icon={FileCheck2}
        actions={hasPerm("proposals:add") && (
          <FormDialog title="New Proposal" fields={fields} onSubmit={create} submitLabel="Create Proposal" testId="create-proposal-dialog"
            trigger={<Button data-testid="create-proposal-btn"><Plus className="h-4 w-4 mr-1.5" /> New Proposal</Button>} />
        )} />
      <DataTable columns={columns} rows={items} loading={loading} rowTestId="proposal-table-row" />
      <Pager page={page} limit={25} total={total} onPage={setPage} />
    </div>
  );
}
